import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';

class StackTeamsChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setStackTeamsIsCheckedForStackNumber(isChecked, this.props.stackNumber));
    }

    render() {
        const {stackNumber, stacking} = this.props;

        const isChecked = stacking.isAllActiveStackTeamsCheckedByStackNumber(stackNumber);

        return (
            <label>
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                All teams
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(StackTeamsChecking);
